<template>
  <header
    data-test-id="top-nav"
    class="sticky top-0 z-50 flex h-14 shrink-0 items-center gap-2 border-b bg-background px-4"
  >
    <div class="flex items-center gap-2">
      <SidebarTrigger />
      <Separator orientation="vertical" class="h-4" />
    </div>
    <div class="flex-1" />
    <div class="flex items-center gap-2">
      <Button
        v-if="
          programRolesRef?.includes(RoleEnumTypeV2.MENTEE) &&
          userActivePermissionGroupRef === PermissionsGroupsEnumType.USER &&
          canAutoMatch &&
          typeof programRef?.settings?.maxGroupPerMentee === 'number' &&
          programRef?.settings?.maxGroupPerMentee > groupsRef?.length
        "
        variant="outline"
        size="sm"
        data-test-id="search-matching-button"
        @click="openNewMatchingModal"
      >
        <UsersIcon class="size-4" />
        {{ t('matching.findMentor') }}
      </Button>
      <PeriodsDropdown />
      <ProgramsDropdown />
    </div>
  </header>
</template>

<script setup lang="ts">
import { UsersIcon } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { selectGetUserActivePermissionGroup } from '@/features/auth/stores/auth/auth.selectors'
import authStore from '@/features/auth/stores/auth/auth.store'
import { PermissionsGroupsEnumType, RoleEnumTypeV2 } from '@/features/auth/types'
import useGroups from '@/features/groups/hooks/use-groups.hook'
import useMatchingSettings from '@/features/matching/hooks/use-matching-settings.hook'
import PeriodsDropdown from '@/features/programs/components/periods-dropdown/periods-dropdown.vue'
import ProgramsDropdown from '@/features/programs/components/programs-dropdown/programs-dropdown.vue'
import useProgram from '@/features/programs/hooks/use-program.hook'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import useProgramRoles from '@/features/users/hooks/use-program-roles.hook'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const { groupsRef } = useGroups()

const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)
const { programRef } = useProgram(selectedProgramIdRef)
const { canAutoMatch } = useMatchingSettings(selectedProgramIdRef)
const { programRolesRef } = useProgramRoles()
const userActivePermissionGroupRef = selectGetUserActivePermissionGroup(authStore)

function openNewMatchingModal() {
  modalsStore.toggleModal('new-matching', true)
}
</script>
